<form [formGroup]="parentForm">
  <div formGroupName="remoteServiceModules">
    <div class="subSectionHeaderWrapper">
      <div class="d-flex justify-content-between align-items-center subSectionHeader">
        <h5 class="m-0">Remote Service Modules</h5>

        <div class="ms-auto d-flex align-items-center">
          <button
            type="button"
            class="btn btn-link p-0 text-decoration-none"
            (click)="openHelpModal.emit('remote-service-modules')"
            data-bs-toggle="modal"
            data-bs-target="#helpModal"
            aria-label="Help"
          >
            <i class="bi bi-question-circle" style="font-size: 1.5rem; color: white"></i>
          </button>

          <i
            style="cursor: pointer; margin-left: 0.5rem"
            [ngClass]="{ 'bi-arrow-up-circle-fill': isThisSectionVisible, 'bi-arrow-down-circle-fill': !isThisSectionVisible }"
            (click)="toggleVisibility()"
          ></i>
        </div>
      </div>
    </div>
    <div [ngStyle]="{ display: isThisSectionVisible ? 'block' : 'none' }">
      <div class="row">
        <div class="col-3">
          <si-newton-form-group
            label="Risk Addition"
            [errorResolverMap]="{ required: 'Value is required', pattern: 'Only integers are allowed here' }"
          >
            <div class="input-group-prepend">
              <span class="input-group-text">%</span>
            </div>
            <input formControlName="remoteServiceRiskAddition" siNewton type="number" step="any" [min]="0" [max]="100" />
          </si-newton-form-group>
        </div>
        <div class="col-9">
          <p class="info">Risk Addition does impact for all services without mlfb</p>
        </div>
      </div>

      <div class="row" style="margin-bottom: 5px">
        <div class="col">
          <b class="subSubSectionHeader">Add a new Remote Service</b>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <si-newton-form-group label="MLFB" [errorResolverMap]="{ required: 'Value is required' }">
            <input formControlName="newRemoteServiceMlfb" siNewton />
          </si-newton-form-group>
        </div>

        <div class="col">
          <si-newton-form-group label="Name" [errorResolverMap]="{ required: 'Value is required' }">
            <input formControlName="newRemoteServiceName" siNewton />
          </si-newton-form-group>
        </div>

        <div class="col">
          <si-newton-form-group label="Description" [errorResolverMap]="{ required: 'Value is required' }">
            <input formControlName="newRemoteServiceDescription" siNewton />
          </si-newton-form-group>
        </div>

        <div class="col">
          <si-newton-form-group label="Period" [errorResolverMap]="{ required: 'Please select an option' }">
            <si-newton-dropdown
              [dropdownOptions]="getDropdownOptions('remoteServicePeriod')"
              [valueProvider]="getDropdownValue"
              formControlName="newRemoteServicePeriod"
            ></si-newton-dropdown>
          </si-newton-form-group>
        </div>

        <div class="col">
          <si-newton-form-group
            label="Quantity"
            [errorResolverMap]="{ required: 'Value is required', pattern: 'Only integers are allowed here' }"
          >
            <input formControlName="newRemoteServiceQuantity" siNewton type="number" [min]="0" />
          </si-newton-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-md-9"></div>

        <div class="col-md-3">
          <button
            type="button"
            class="btn btn-success"
            style="float: right"
            [disabled]="!isNewServiceValid()"
            (click)="updateRemoteServiceList()"
          >
            Add Service
          </button>
        </div>
      </div>

      <div class="row">
        <div *ngIf="areNullValuesInPricesPresent === true">
          <p class="warnInfo">
            There are Components with no price. This could mean that we could'nt get the prices. Please adapt manually.
          </p>
        </div>
      </div>

      <div *ngFor="let _ of [].constructor(allRemoteServiceModules.length); let x = index">
        <div class="customCard">
          <div class="row">
            <div class="col-12">
              <p>
                <b>{{ allRemoteServiceModules[x].serviceName }}</b>
              </p>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12">
              <p><b>MLFB</b></p>
              {{ allRemoteServiceModules[x].mlfb }}
            </div>

            <div class="col-lg-2 col-md-3 col-sm-6 col-xs-12">
              <p><b>Period</b></p>
              {{ allRemoteServiceModules[x].period }}
            </div>

            <div class="col-lg-2 col-md-3 col-sm-6 col-xs-12">
              <p><b>Quantity</b></p>
              {{ allRemoteServiceModules[x].quantity }}
            </div>
            <div class="col-lg-2 col-md-3 col-sm-6 col-xs-12">
              <si-newton-form-group label="Service Cost">
                <div class="input-group-prepend">
                  <span class="input-group-text">€</span>
                </div>
                <input formControlName="remoteServiceCost{{ x + 1 }}" type="number" step="any" [min]="0" siNewton />
              </si-newton-form-group>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-6 col-xs-12">
              <p><b>Selected?</b></p>
              <div class="form-check">
                <input class="form-check-input" formControlName="remoteServiceSelected{{ x + 1 }}" type="checkbox" />
              </div>
            </div>

            <div class="col-lg-2 col-md-3 col-sm-6 col-xs-12">
              <button title="Delete Service" class="btn-danger" (click)="deleteService(allRemoteServiceModules[x].serviceNumber)">
                <i class="bi bi-trash"></i>
              </button>
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <p><b>Description</b></p>

              {{ allRemoteServiceModules[x].serviceDescription || "No detailed description available" }}
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-bottom: 10px">
        <div class="col-md-9"></div>

        <div class="col-md-3">
          <button
            type="button"
            class="btn btn-success"
            (click)="getPricesForAllMlfbs()"
            [disabled]="allRemoteServiceModules.length === 0"
            style="float: right"
          >
            Update List Prices
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
